import { z } from 'zod'

/**
 * The global report Bcc (CLI-850): addresses Bcc'd on every real send of every report Headline
 * delivers — how staff join each tranche's distribution list without editing every report. Added
 * at send time, never written into a report, so it is staff's list alone: only staff may read or
 * change it, and a report's Delivery tab shows it (greyed, not removable) to staff only. Test sends
 * and RTAs never carry it.
 */
export const GLOBAL_REPORT_BCC_MAX = 50

export const globalReportBccSchema = z.object({
  addresses: z.array(z.string()),
  updatedBy: z.string().nullable(),
  updatedAt: z.iso.datetime().nullable(),
})
export type GlobalReportBcc = z.infer<typeof globalReportBccSchema>

export const setGlobalReportBccSchema = z.object({
  addresses: z.array(z.email()).max(GLOBAL_REPORT_BCC_MAX),
})
export type SetGlobalReportBcc = z.infer<typeof setGlobalReportBccSchema>

/** What a reader sees before anyone has saved the list: nobody. */
export function emptyGlobalReportBcc(): GlobalReportBcc {
  return { addresses: [], updatedBy: null, updatedAt: null }
}

/**
 * The list as stored: trimmed, lower-cased, each address once, in the order typed. Lower-cased
 * because the mailer's dedup is, and an address saved twice in two spellings is one person.
 */
export function normalizeBccAddresses(addresses: readonly string[]): string[] {
  const kept = new Set<string>()
  for (const raw of addresses) {
    const address = raw.trim().toLowerCase()
    if (address !== '') kept.add(address)
  }
  return [...kept]
}
